module.exports = __webpack_public_path__ + "static/orderStep2-41243593b394ecb0ba25d169a23b258f.png";